import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=56907d74&scoped=true"
import script from "./Drawer.ts?vue&type=script&lang=ts&external"
export * from "./Drawer.ts?vue&type=script&lang=ts&external"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=56907d74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56907d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56907d74')) {
      api.createRecord('56907d74', component.options)
    } else {
      api.reload('56907d74', component.options)
    }
    module.hot.accept("./Drawer.vue?vue&type=template&id=56907d74&scoped=true", function () {
      api.rerender('56907d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Uploader/components/Drawer/Drawer.vue"
export default component.exports